import { Button } from '@chakra-ui/react';
import { string } from 'yaml/dist/schema/common/string';

export default function StyledButton(
  props: {
    text: string;
    variant?: 'outline' | 'solid' | 'danger';
    id?: string;
    onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
    fillWidth?: boolean;
    disabled?: boolean;
  } = {
    variant: 'solid',
    text: '',
    fillWidth: false,
    disabled: false,
  },
) {
  const isSolid = props.variant === 'solid';
  const isDanger = props.variant === 'danger';

  return (
    <Button
      flex={props.fillWidth ? 1 : "none"}
      variant={isSolid ? 'solid' : 'outline'}
      color={isSolid || isDanger ? 'cardDefault' : 'accentButtonDefault'}
      backgroundColor={isSolid ? 'accentButtonDefault' : isDanger ? 'accentRed' : 'transparent'}
      borderColor={isDanger ? 'accentRed' : 'accentButtonDefault'}
      borderWidth="1px"
      borderStyle="solid"
      _active={{ bg: 'accentButtonActive' }}
      _hover={{
        color: 'accentButtonActive',
        bg: 'accentButtonHover',
        borderColor: 'accentButtonHover',
        cursor: 'pointer',
      }}
      onClick={props.onClick}
      id={props.id}
      disabled={props.disabled}
    >
      {props.text}
    </Button>
  );
}
